import React, {useEffect, useState} from 'react';
import Container from '@material-ui/core/Container';
import {getUserDataFromLocalStorage} from "../../services/utils";
import {useStyles} from "../auth/signIn/authStyles";
// import {initialState} from "./constant";
import Alert from "../../components/alert";
import {Paper} from '@material-ui/core'
import {DashboardHeader} from "../../components";
import HttpService from "../../services/http.service";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

export default function SavedAlerts(props) {
  const classes = useStyles();
  // const [state, setState] = useState(initialState);

  const [error] = useState("")
  const [success] = useState("")

  const data = [3, 3, 3, 3, 3, 3, 3, 3]
  const [loading, setLoading] = useState(true)
  const [searches, setSearches] = useState([])
  let loginUser = getUserDataFromLocalStorage()
  useEffect(() => {
    setLoading(true)
    HttpService.get('api/list/alerts').then(res => {
      if (res) {
        setSearches(res.data)
        setLoading(false)
      }
    });
  }, []);
  const addNewAlert = () => {
    props.history.push('addalert')
  }

  return (
    <>
      {((error || success)) &&
      <Alert type={error ? 'error' : 'success'}
             message={error || success}/>
      }

      <Container className={`mb-20 p-20 content-main-container  `}>
        <div className={classes.paper} style={{marginTop: 0}}>
          <DashboardHeader pageTitle={'Saved Alerts'} addNewItem={'add new alert'} addNewHandler={addNewAlert}/>

          {/*<div>*/}
          {/*  <h1 className='align-self-start text-normal'>Saved Alerts</h1>*/}
          {/*  <p></p>*/}
          {/*</div>*/}
          <div className='full-width mt-10'>
            {(searches || []).map((item, index) => {
              return (
                // <div>{item.description}</div>
                <Paper elevation={2} variant='outlined'
                       className='bg-white display-flex align-items-center justify-content-between pl-40 pr-40 mt-10'>
                  <p className='' style={{textTransform: '',}}>{item.alertText}</p>
                  <InsertDriveFileIcon style={{color: 'rgba(0, 0, 0, 0.53)'}}/>
                </Paper>
              )
            })}
          </div>
        </div>
      </Container>
    </>
  );
}
